(function() {
  
  /**
   * @ngdoc factory
   * @name RcConsumableList
   * @description Model for the consumable summarization list, wrapped for reseller console to allow Demo mode
   */
  angular
    .module('rcEntities.rcConsumableList', ['binky.core.product.consumable'])
    .factory('RcConsumableList', getProductListModel);

  /* @ngInject */
  function getProductListModel(
    $injector,
    $q,
    _,
    ConsumableSummarization,
    ConsumableSummarizationList,
    DemoMode
  ) {
    class RcConsumableList extends ConsumableSummarizationList {
      /**
       * @description Method to refresh Product list from back-end.
       * @returns {Promise} resolves to ProductList on success, else rejects with error
       */
      refresh() {
        if (DemoMode.isEnabled()) {
          // Do not call JIL in demo mode; set up the list via MiniJil.
          const deferred = $q.defer();
          this.$promise = deferred.promise;
          // avoid circular dependency
          const MiniJil = $injector.get('MiniJil');
          MiniJil.getConsumableList(this.organization_id).then(responseData => {
            this.items = _.map(responseData, item =>
              ConsumableSummarization.apiResponseTransformer(item)
            );
            deferred.resolve(this);
          });
          return deferred.promise;
        } else {
          return super.refresh();
        }
      }

      /**
       * @description Method to fetch the RcProductList.
       * @param {Object} [options] - options to configure the product list.
       * @returns {ProductList} the fetched RcProductList.
       */
      static get(options) {
        const model = new RcConsumableList(options);
        model.refresh();
        return model;
      }
    }

    return RcConsumableList;
  }
})();
